import { CityFragment } from 'pages/city/api/fragments/generated/City.fragment';

type TGetCity = { cityId?: string | null; cities: CityFragment[] };

export const getCity = ({ cityId, cities }: TGetCity) => {
  const res = cities.find(facilityGroup => facilityGroup.id === cityId);
  if (!res) return null;
  return res;
};
